var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 46,
    viewBox: "0 0 55 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_105_27)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_105_27)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 35V9C4.25 6.92893 5.92893 5.25 8 5.25H19.3664C20.2918 5.25 21.1845 5.59217 21.8729 6.21073L22.6903 6.9453L22.8574 6.75935L22.6903 6.9453C23.4704 7.64632 24.4822 8.03412 25.531 8.03412H43C45.071 8.03412 46.75 9.71305 46.75 11.7841V35C46.75 37.071 45.071 38.75 43 38.75H8C5.92893 38.75 4.25 37.071 4.25 35Z",
    fill: "white",
    stroke: "#6B77C4",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_105_27",
    x: 0,
    y: 0,
    width: 55,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.027451 0 0 0 0 0.101961 0 0 0 0.16 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_105_27"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_105_27",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_105_27"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFolder);
export default __webpack_public_path__ + "static/media/whiteFolder.81496033cbb18f52be0bebdafa79b372.svg";
export { ForwardRef as ReactComponent };